module.exports = __webpack_public_path__ + "assets/plugin.89644ee2.svg";